import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { LoyaltyPointsStatus as LoyaltyPointsStatusBase } from "./LoyaltyPointsStatus";

export type * from "./LoyaltyPointsStatus";
export const LoyaltyPointsStatus = withLoyaltyStore(LoyaltyPointsStatusBase, "LoyaltyPointsStatus");
